export default __webpack_public_path__ + "96c52688255c4bdb23e9b332b00a1384.png";